// The nav steps and placeholder screen names as plain data, free of React, so
// scripts/check-i18n.ts and the i18n test can assert that every one of them
// has a string in both catalogues: a template-literal t() cannot be checked
// by the reference scanner beyond its static prefix.

/** The six steps of the book nav: i18n key in the `nav` namespace and the route segment. */
export const BOOK_STEPS = [
  { key: "step1", segment: "overview" },
  { key: "step2", segment: "chapters" },
  { key: "step5", segment: "casting" },
  { key: "step3", segment: "style-sheet" },
  { key: "step4", segment: "review" },
  { key: "step6", segment: "render" },
] as const;

export type StepKey = (typeof BOOK_STEPS)[number]["key"];

/** Placeholder screen names, each a key under `common:screens.*`. */
export const SCREEN_KEYS = [
  "chapters",
  "styleSheet",
  "review",
  "casting",
  "render",
  "renderProgress",
  "audiobook",
] as const;

export type ScreenKey = (typeof SCREEN_KEYS)[number];
